import React from "react";

import { AmountsProps } from "./types";
import { useAmounts } from "./hooks";

export const Amounts = (props: AmountsProps) => {
  const { getAmountsProps, getButtonProps, values } = useAmounts(props);
  return (
    <div {...getAmountsProps()}>
      {values.amounts.map((amount, index) => (
        <button
          key={index}
          {...getButtonProps({
            value: amount,
          })}
        >
          <span>
            {amount} {values.balanceLabel}
          </span>
        </button>
      ))}
    </div>
  );
};
